import { render, staticRenderFns } from "./PageForBusinessServe.vue?vue&type=template&id=6ab27d5b&scoped=true&"
import script from "./PageForBusinessServe.vue?vue&type=script&lang=js&"
export * from "./PageForBusinessServe.vue?vue&type=script&lang=js&"
import style0 from "./PageForBusinessServe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab27d5b",
  null
  
)

export default component.exports